import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { stepper, validStep, validBackStep } from "./reducers/stepper";
import { signingInfo, } from "./reducers/signingInfo";
import { currentWaiver } from "./reducers/waiverInfo"
import { opentok, recording, } from './reducers/recorder'
import { signedWaiver, locationData, pathParticipants, pathInfo } from './reducers/signedWaiver'



const middlewares = [];

const enhancer = composeWithDevTools(
  applyMiddleware(thunk, ...middlewares)
  // other store enhancers if any
);


const store = createStore(combineReducers({
  signingInfo,
  stepper,
  opentok,
  recording,
  signedWaiver,
  locationData,
  pathParticipants,
  pathInfo,
  validStep,
  validBackStep,
  currentWaiver,
}), enhancer);


export default store;
